import React, { useEffect, useState } from 'react';
import classes from './FactoryCharacteristics..module.css';
import { Box, Paper, Select, SimpleGrid, Space, Text, TextInput } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { IoAddOutline, IoTrashOutline } from "react-icons/io5";
import { baseUrl } from '../../../../../Constants/constant';
import useFetch from '../../../../../Customhooks/useFetch';

interface FormField {
    id_comp: number;
    // country: string | null;
    id: number | null;
    process_name: string;
    percentage_of_factory: string;
}

interface FactoryCharacteristicsProps {
    onFieldsChange: (fields: FormField[]) => void;
    onValidationChange: (isValid: boolean) => void;
    showErrors: boolean;
    initialFields?: FormField[];
}

const FactoryCharacteristics: React.FC<FactoryCharacteristicsProps> = ({
    onFieldsChange,
    onValidationChange,
    showErrors,
    initialFields,

}) => {
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [processes , setProcesses ] = useState<any[]>([]);
    const [fields, setFields] = useState<FormField[]>([{
        id_comp: 1,
        // country: null,
        id: null,
        process_name: "",
        percentage_of_factory: "",
    }]);

    const { id } = useParams();
    const token = localStorage.getItem("token");

    const { data: getProcessData, fetchData: fetchProcess } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });

    useEffect(() => {
        onFieldsChange(fields);
        const isValid = validateFields();
        onValidationChange(isValid);
    }, [fields]);

    useEffect(()=>{
        fetchProcess(`${baseUrl}admin/process`)
    },[])
    

    useEffect(() => {
        if (getProcessData?.data?.rows) {
            const ProcessOptions = getProcessData?.data?.rows?.map((el: any) => ({
                value: el?.id?.toString(),
                label: el?.process_name,
            }));
            setProcesses(ProcessOptions);
        }
    }, [getProcessData]);

    useEffect(() => {
        if (initialFields && initialFields?.length > 0) {
            const updatedFields = initialFields?.map(field => ({
                ...field,
                process_name: field?.process_name?.toString() || "",
                percentage_of_factory: field?.percentage_of_factory?.toString() || ""
            }));
            setFields(updatedFields);
        }
    }, [initialFields]);




    const validateFields = () => {
        const newErrors: Record<string, string> = {};
        let isValid = true;

        fields.forEach((field, index) => {
            // Required field validations
            // if (!field.country) {
            //     newErrors[`country_${index}`] = "Country is required";
            //     isValid = false;
            // }
            if (!field.process_name) {
                newErrors[`process_type_${index}`] = "Process name is required";
                isValid = false;
            }


            if (!field.percentage_of_factory) {
                newErrors[`percentage_${index}`] = "Percentage is required";
                isValid = false;
            } else {
                const percentageValue = Number(field.percentage_of_factory);
                if (isNaN(percentageValue)) {
                    newErrors[`percentage_${index}`] = "Must be a valid number";
                    isValid = false;
                } else if (percentageValue < 0 || percentageValue > 100) {
                    newErrors[`percentage_${index}`] = "Percentage must be between 0 and 100";
                    isValid = false;
                }
            }
        });

        setErrors(newErrors);
        onValidationChange(isValid);
        return isValid;
    };


    const handleChange = (index: number, field: keyof FormField, value: string | null) => {
        setFields(prev => {
            const newFields = [...prev];

            // Update the current field value
            newFields[index] = {
                ...newFields[index],
                [field]: value
            };

            return newFields;
        });
    };
    useEffect(() => {
        onFieldsChange(fields);
        if (showErrors) {
            validateFields();
        }
    }, [fields, showErrors]);

    const addComponent = () => {
        // Reset all errors
        setErrors({});
        // Reset show errors state in parent component if needed
        if (onValidationChange) {
            onValidationChange(true);
        }

        // Add new component
        setFields(prev => [...prev, {
            id_comp: prev.length + 1,
            id: null,
            process_name: "",
            location_based_emission: "",
            fuel_based_emission: "",
            market_based_emission: "",
            percentage_of_factory: "",
        }]);
    };
    const handledeletecomponent = (id_comp: any) => {
        setFields(prev => prev.filter(field => field.id_comp !== id_comp));
    };

    return (
        <div>
            {fields?.map((field, index) => (
                <Paper className={classes.productdiv} key={field?.id_comp} shadow="xs" p="xs" radius="md" mb={10}>
                    <Space />
                    {fields?.length > 1 && (
                        <Box className={classes.delete_box}>
                            <IoTrashOutline
                                fill="red"
                                size={20}
                                onClick={() => handledeletecomponent(field.id_comp)}
                            />
                        </Box>
                    )}

                    <Box ml={5}>
                        <SimpleGrid cols={4}>
                            <Select
                                label="Add Process"
                                withAsterisk
                                placeholder="Process"
                                data={processes}
                                variant='filled'
                                searchable
                                radius={6}
                                maxDropdownHeight={200}
                                value={field?.process_name}
                                onChange={(value) => handleChange(index, "process_name", value)}
                                error={showErrors ? errors[`process_type_${index}`] : null}
                            />

                            <TextInput
                                label="Add Percentage (%) of Factory for Process"
                                withAsterisk
                                placeholder="Enter Percentage"
                                variant="filled"
                                value={field?.percentage_of_factory}
                                onChange={(e) => handleChange(index, "percentage_of_factory", e.target.value)}
                                error={showErrors ? errors[`percentage_${index}`] : null}
                            />
                            <TextInput
                                value={field?.id_comp}
                                onChange={(e) => handleChange(index, "id", e.target.value)}
                                style={{ display: 'none' }}
                            />
                        </SimpleGrid>
                    </Box>
                    <Space h="sm" />
                </Paper>
            ))}
            <Box className={classes.addmoreleg}>
                <span style={{ display: 'flex' }}><IoAddOutline size={18} /></span>
                <Text
                    variant="default"
                    onClick={addComponent}
                    ta="right"
                    pl={4}
                >
                    Add More Process
                </Text>
            </Box>
        </div>
    );
};

export default FactoryCharacteristics;